import { useProptPrice } from '../hooks/useProptPrice';

const ProptPrice = () => {
     const price = useProptPrice();

     return (
          <p style={{ display: 'inline' }}>
               {price === null ? (
                    '...'
               ) : (
                    `$${parseFloat(String(price).replace(',', '.')).toFixed(2)}`
               )}
          </p>
     );
};

export default ProptPrice;